import React from 'react';
import { socialData } from '../../../data/socialData';
import { FaInstagram, FaFacebookF, FaLinkedinIn, FaWhatsapp, FaXTwitter, FaEnvelope, FaPhone } from 'react-icons/fa6';

export default function NavContact() {
  return (
    <div className="bg-black w-full text-[14px] flex flex-row justify-between items-center text-white p-2">
      
      {/* Left Section: Clickable Email & Contact */}
      <div className="flex items-center space-x-6">
        {/* Clickable Email */}
        <a href={`mailto:${socialData.mail}`} className="contact-item hover:text-[#C9A227] flex justify-center items-center gap-3 ">
          <FaEnvelope size={18} />
          <span>{socialData.mail}</span>
        </a>

        
        <a href={`tel:${socialData.contact1}`} className="contact-item hover:text-[#C9A227] flex justify-center items-center gap-3">
          <FaPhone size={18} />
          <span>{socialData.contact1}</span>
        </a>
        <a href={`tel:${socialData.contact2}`} className="contact-item hover:text-[#C9A227] flex justify-center items-center gap-3">
          <FaPhone size={18} />
          <span>{socialData.contact2}</span>
        </a>
      </div>

      {/* Right Section: Social Media Icons */}
      <div className="flex space-x-4">
        <a href={socialData.instagram} target="_blank" rel="noopener noreferrer" className="social-icon hover:text-[#C9A227]">
          <FaInstagram size={18} />
        </a>
        <a href={socialData.facebook} target="_blank" rel="noopener noreferrer" className="social-icon hover:text-[#C9A227]">
          <FaFacebookF size={18} />
        </a>
        <a href={socialData.linkedin} target="_blank" rel="noopener noreferrer" className="social-icon hover:text-[#C9A227]">
          <FaLinkedinIn size={18} />
        </a>
        <a href={socialData.whatsapp} target="_blank" rel="noopener noreferrer" className="social-icon hover:text-[#C9A227]">
          <FaWhatsapp size={18} />
        </a>
        <a href={socialData.x} target="_blank" rel="noopener noreferrer" className="social-icon hover:text-[#C9A227]">
          <FaXTwitter size={18} />
        </a>
      </div>

    </div>
  );
}
